import _ from 'lodash';
import React from 'react';

const initialState: any = {
	active: null
}

const getCategoryItem = (items: any) => {
	const item = items?.find((item: any) => item.isCategoryMenu) || null;
	return item;
}

export const DesktopMenuContext = React.createContext<any>({})

const DesktopMenuProvider: React.FC<any> = ({ children, theme, config, items }) => {
	const [store, updateStore] = React.useState<any>({
		...initialState,
		//active: items[0].id
	});

	const navRef = React.useRef<any>(null);
	const verticalNavRef = React.useRef<any>(null);

	const setState = (key: string, value: any) => {
		if (!(key in initialState)) {
			throw Error(`Key ${key} is not valid state.`);
		}
		updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value }))
	}

	const handleSelect = (itemID: number | null) => {
		if ( store.active === itemID ) return;
		handleReset.cancel();
		setState('active', itemID);
	}

	const handleReset = _.debounce(() => {
		setState('active', null);
	}, 250);

	return (
		<DesktopMenuContext.Provider
			value={{
				...store,
				navRef,
				verticalNavRef,
				theme,
				config,
				items,
				handleReset,
				handleSelect,
				setState,
			}}
			children={children}
		/>
	)
}

export default DesktopMenuProvider;